import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import firebase from '../../config/firebase';
import { useSelector } from 'react-redux';
import { render } from '@testing-library/react';
import InputMask from 'react-input-mask';
import Stack from '@mui/material/Stack';
import { Chip } from '@mui/material';
import { Tooltip } from 'antd';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GlobalSuccessModal, GlobalConfirmModal } from '../modalGlobal/modalGlobal';

require('firebase/auth')

const CustomPaginationActionsTable = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [datas, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const searchInput = useRef(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const user = useSelector(state => state.user)

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const fetchUsersByShipperUids = async (uids) => {
    const collectionRef = firebase.firestore().collection("user_web");
    const uniqueUids = Array.from(
      new Set((uids || []).filter((uid) => Boolean(uid))),
    );

    if (uniqueUids.length === 0) {
      return { docs: [] };
    }

    if (uniqueUids.length === 1) {
      return collectionRef.where("uidShipper", "==", uniqueUids[0]).get();
    }

    const chunks = [];
    for (let i = 0; i < uniqueUids.length; i += 10) {
      chunks.push(uniqueUids.slice(i, i + 10));
    }

    const snapshots = await Promise.all(
      chunks.map((chunk) =>
        collectionRef.where("uidShipper", "in", chunk).get(),
      ),
    );

    const docsById = new Map();
    snapshots.forEach((snap) => {
      snap.docs.forEach((doc) => {
        docsById.set(doc.id, doc);
      });
    });

    return { docs: Array.from(docsById.values()) };
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let snapshot;

      if (user?.viewALL) {
        snapshot = await firebase.firestore().collection("user_web").get();
      } else {
        const affiliateUids = Array.isArray(user?.uidShipperAffiliates)
          ? user.uidShipperAffiliates
          : [];
        const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
        const uids = [...affiliateUids, ...primaryUid];

        snapshot = await fetchUsersByShipperUids(uids);
      }

      const documents = (snapshot?.docs || []).map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setData(documents);
    } catch (error) {
      console.error("Erro ao buscar dados dos usuários:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user?.viewALL, user?.uidShipper, user?.uidShipperAffiliates]);

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleDeleteClick = (id) => {
    setUserToDelete(id);
    setOpenConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmModal(false);
    if (!userToDelete) return;
    try {
      await firebase.firestore().collection('user_web').doc(userToDelete).delete()
      setOpenSuccessModal(true);
      fetchData();
    } catch (error) {
      console.error("Erro ao excluir usuário:", error);
    }
  };

  function renderStatusColor(status) {
    const chipStyle = {
      minWidth: '100px',
      maxWidth: '150px',
      // overflow: 'hidden', // Esconde o texto que excede a largura máxima
      // textOverflow: 'ellipsis', // Adiciona "..." ao final do texto que excede a largura
      // whiteSpace: 'nowrap', // Impede a quebra de linha
    };

    const commonChip = (label, color) => (
      <Stack direction="row" spacing={1} justifyContent="center">
        <Chip label={label} color={color} style={chipStyle} />
      </Stack>
    );

    const isAtivo = status === 'Ativo';
    if (isAtivo) {
      return commonChip('Ativo', 'primary');
    } else {
      return commonChip('Inativo', 'warning');
    }
  }


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
          position: dataIndex === 'name' ? 'relative' : '',
          left: dataIndex === 'name' ? '05' : '0px',
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilter: (value, record) => {

      if (dataIndex === 'cpf') {
        const cleanValue = value.replace(/[^\w]/g, '').trim();

        const documentNumber = record.cpf
          ? record.cpf.toString().replace(/[^\w]/g, '').toLowerCase().trim()
          : '';

        return documentNumber.includes(cleanValue.toLowerCase());
      }
      else if (typeof value === 'string') {
        return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase())
      }
      else {
        return record[dataIndex] = value
      }

    }, onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      width: '15%',
      ...getColumnSearchProps('cpf'),
      sorter: (a, b) => a.cpf.localeCompare(b.cpf),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
      ...getColumnSearchProps('email'),
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Telefone',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      ...getColumnSearchProps('phoneNumber'),
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: 'Perfil',
      dataIndex: 'perfil',
      key: 'perfil',
      ...getColumnSearchProps('perfil'),
      sorter: (a, b) => a.perfil.localeCompare(b.perfil),
      render: (text) => text ? text.charAt(0).toUpperCase() + text.slice(1) : '',
    },
    {
      title: 'Status',
      dataIndex: 'ativo',
      key: 'ativo',
      align: 'center',
      ...getColumnSearchProps('ativo'),
      render: (ativo) => {
        const describeText = ativo === 'Ativo' ? 'Ativo' : 'Inativo';
        return (
          <Tooltip title={describeText}>
            <div>
              {renderStatusColor(describeText)}
            </div>
          </Tooltip>
        );
      },
      sorter: (a, b) => a.ativo.localeCompare(b.ativo),
    },
    {
      title: 'Ações',
      width: '10%',
      // dataIndex: 'data',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {
            user?.permissoes?.user?.isEdit || user?.permissoes?.usuario?.editar ? (
              <Link to={'/newUser/' + record.id}>
                <EditOutlinedIcon />
              </Link>
            )
              :
              (
                <Link to={`/newUser/${record.id}`} state={{ viewOnly: true }}>
                  <VisibilityIcon />
                </Link>
              )
          }
          {
            user?.permissoes?.user?.isDelete || user?.permissoes?.usuario?.excluir ? (
              <DeleteOutlinedIcon onClick={() => handleDeleteClick(record.id)} color='error' style={{ cursor: "pointer" }} />
            )
              :
              (
                ""
              )
          }
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={datas} loading={loading} />

      <GlobalConfirmModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Deseja mesmo excluir esse usuário?"
        subtitle="Esta ação não poderá ser desfeita."
      />
      <GlobalSuccessModal
        open={openSuccessModal}
        handleClose={() => setOpenSuccessModal(false)}
        title="Usuário excluído com sucesso!"
      />
    </>
  );
};

export default CustomPaginationActionsTable;